import React, { useCallback, useEffect, useState } from "react";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FormControl } from "ui";
import { FIELDS, GMB_TOPICS } from "constants/PostFormFields";
import { useDebouncedCallback } from "use-debounce";
import { TextInput } from "ui/ecosystems/forms/inputs";
import { useRegisterFlush } from "../../platform-fields/flush-registry";

const PostCoupon = ({
  topicType,
  post,
  selectedPlatform,
  platforms,
  disabled = false,
  onChange,
  className = "",
}) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (post["gmbOffer"] && post["gmbOffer"]["couponCode"]) {
      setValue(post["gmbOffer"]["couponCode"]);
    }
  }, []);
  const bounce = useDebouncedCallback((value) => {
    onChange({ [FIELDS.GMB_COUPON_CODE]: value });
  }, 500);
  // Registered before the early return below so the hook runs unconditionally.
  useRegisterFlush(bounce.flush);

  const flushPending = useCallback(() => {
    bounce.flush();
  }, [bounce]);

  useEffect(() => {
    return () => {
      bounce.flush();
    };
  }, [bounce]);

  const forTopics = [GMB_TOPICS.OFFER.VALUE];
  if (!forTopics.includes(topicType)) {
    return "";
  }

  return (
    <div className={className}>
      <div className="flex items-center">
        <PostFieldLabel className="mb-2 mr-4">
          Coupon code (optional)
        </PostFieldLabel>
        <PlatformUsage
          platforms={platforms}
          field={FIELDS.GMB_TOPIC_TYPE}
          selectedPlatform={selectedPlatform}
        />
      </div>
      <TextInput
        value={value}
        placeholder="SALE10"
        onChange={(value) => {
          const newVal = value;
          setValue(newVal);
          bounce(newVal);
        }}
        onBlur={flushPending}
        disabled={disabled}
      />
    </div>
  );
};

export default PostCoupon;
